import { create } from 'zustand';
import type { Session, User } from '@supabase/supabase-js';
import { supabase } from '../supabase.js';

interface SessionState {
  session: Session | null;
  user: User | null;
  loading: boolean;
  init(): Promise<void>;
  signOut(): Promise<void>;
}

export const useSession = create<SessionState>((set) => ({
  session: null,
  user: null,
  loading: true,
  async init() {
    const { data } = await supabase.auth.getSession();
    set({ session: data.session, user: data.session?.user ?? null, loading: false });
    supabase.auth.onAuthStateChange((_evt, session) => {
      set({ session, user: session?.user ?? null });
    });
  },
  async signOut() {
    await supabase.auth.signOut();
    set({ session: null, user: null });
  },
}));
